/**
 * Where the inbox lives, in one place.
 *
 * The inbox is its own full-width page at /account/inbox (2026-09-29). It
 * was the Inbox tab of My Account before that, and the page at /inbox before
 * THAT — both old forms still redirect here (App.js, Account.jsx), thread id
 * included. Order history lives here too, in the Orders folder, since the
 * account page's Orders tab was removed.
 *
 * Everything that links into the inbox goes through these helpers, so the
 * destination has one definition — it has moved twice already.
 *
 * Query parameters:
 *   folder  all | unread | orders | support | archive   (default: all)
 *   thread  a conversation id
 *   order   an order id — opens that order, in the Orders folder
 *   status  Orders folder only: show one order status (e.g. in_transit)
 *   open    "action" — auto-open the newest item waiting on the customer
 */
export const INBOX_BASE = "/account/inbox";

const build = (params) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && !(k === "folder" && v === "all")) qs.set(k, String(v));
  });
  const s = qs.toString();
  return s ? `${INBOX_BASE}?${s}` : INBOX_BASE;
};

/** A conversation, or the inbox itself. Also accepts an options object. */
export const inboxPath = (threadIdOrOpts) =>
  threadIdOrOpts && typeof threadIdOrOpts === "object"
    ? build(threadIdOrOpts)
    : build({ thread: threadIdOrOpts });

/** The Orders folder, optionally opened on one order or filtered by status. */
export const ordersPath = (orderId, { status } = {}) =>
  build({ folder: "orders", order: orderId, status });

export default inboxPath;
